import React, { PropsWithChildren } from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';

import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

type CheckoutWidgetProps = PropsWithChildren<{
    style?: StyleProp<ViewStyle>;
}>;

export const CheckoutWidget = ({ children, style }: CheckoutWidgetProps) => {
    return (
        <Box
            borderRadius={'r16'}
            backgroundColor={ds.colorToken.background.neutral.subtler}
            borderWidth={1}
            style={[styles.border, style]}
        >
            {children}
        </Box>
    );
};

const styles = StyleSheet.create({
    border: {
        borderColor: ds.colorValue.border.subtle,
        padding: 15,
    },
});
